import { BRANDS, HUB_THEMES, resolveBrandName } from "./brands";
import type { BrandConfig, BrandName, HubTheme } from "./brands";

/**
 * The active brand, resolved once from `VITE_BRAND` at module load.
 *
 * Everything brand-aware reads from here (or from `hubTheme` below) — there is
 * no second place that inspects `import.meta.env.VITE_BRAND`.
 */
export const brandName: BrandName = resolveBrandName(
  import.meta.env.VITE_BRAND,
);

export const brandConfig: BrandConfig = BRANDS[brandName];

/** Profile-hub tokens for the active brand. */
export const hubTheme: HubTheme = HUB_THEMES[brandName];
